export default {
    message: "Os itens listados abaixo estão fora de estoque e foram removidos do seu carrinho. Faça seleções diferentes.",
    buttons: {
        ok: "OK"
    }
}